import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		user: null,
		snack: null,
		section: '',
		fileUploading: false,
		fileUploaded: false,
		fileProgress: 0,
		statusDrawer: true,
		actual: 'inicio'
	},

	getters: {
		user: state => state.user,
		snack: state => state.snack,
		section: state => state.section,
		fileUploading: state => state.fileUploading,
		fileUploaded: state => state.fileUploaded,
		fileProgress: state => state.fileProgress,
		statusDrawer: state => state.statusDrawer,
		actual: state => state.actual,
	},
	  
  	mutations: {
		set_user(state, payload) {
			if (payload != null) {
				state.user = payload;
			} else {
				state.user =  null;
			}
	  	},
	  	set_snack(state, payload) {
			if (payload != null) {
				state.snack = {};
				state.snack.kind = payload.kind;
				state.snack.text = payload.text;
			} else {
				state.snack =  null;
			}
		},
		set_section(state, payload) {
			state.section = payload;
	  	},
		set_fileUploading(state, payload) {
			state.fileUploading = payload;
		},
		set_fileUploaded(state, payload) {
			state.fileUploaded = payload;
			state.fileProgress = 0;
		},
		set_fileProgress(state, payload) {
			state.fileProgress = payload;
		},
		set_statusDrawer(state, payload) {
			state.statusDrawer = payload;
		},
		set_actual(state, payload) {
			state.actual = payload;
		}
	},

  	actions: {
		setUser(ctx, payload) {
			if (payload != null) { 
				ctx.commit('set_user', payload);
				return true;
			} else {
				return Sign.signout()
								.then(response => {
									if (response === true) {
										ctx.commit('set_user', null);
										return true;
									}
								});
			}
		},

		setSection(ctx, payload) {
			ctx.commit('set_section', payload);
		},
		
		setSnack(ctx, payload) {
			ctx.commit('set_snack', payload);
		},

		setFileUploading(ctx, payload) {
			ctx.commit('set_fileUploading', payload);
		},

		setFileUploaded(ctx, payload) {
			ctx.commit('set_fileUploaded', payload);
		},

		setFileProgress(ctx, payload) {
			ctx.commit('set_fileProgress', payload);
		},

		setStatusDrawer(ctx, payload) {
			ctx.commit('set_statusDrawer', payload);
		},

		setActual(ctx, payload) {
			ctx.commit('set_actual', payload);
		},
  	}
})
